import styled from 'styled-components';
import { colors } from '../../../theme';

export const UnsupportedDeviceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 100vh;
  padding: 24px;
  background-color: ${colors.white};

  .unsupported-device-icon {
    max-width: 260px;
    width: 80%;
    height: auto;
    margin-bottom: 32px;
  }

  .unsupported-device-title {
    color: #e02b1d;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    margin-bottom: 16px;
  }

  .unsupported-device-message {
    color: ${colors.subTitle};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    max-width: 320px;
  }
`;

export default UnsupportedDeviceContainer;
